import * as api from '../../api/carga-archivo-actualizacion-cia-client';
import { 
    GET_CARGAS_PREVIAS_ACT,
    POST_CARGAR_ARCHIVO_ACT,
    GET_INGRESO_PAGOS_ACT, 
    GET_COMBO_TIPO_MOVIMIENTO

} from '../types';


export const cargasPreviasAction = (query) => ({
    type: GET_CARGAS_PREVIAS_ACT,
    payload: api.getCargasPrevias(query)
});

export const obtenerIngresoPagosExcel = (query) => ({
    type: GET_INGRESO_PAGOS_ACT,
    payload: api.getIngresoPagos(query)
});

export const cargarArchivoAction = (file) => ({
    type: POST_CARGAR_ARCHIVO_ACT,
    payload: api.postCargarArchivo(file)
})

export const obtenerComboTipoMovimiento = (query) => ({
    type: GET_COMBO_TIPO_MOVIMIENTO,
    payload: api.getComboTipoMovimientos(query)
})